"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsMorph_exports = {};
__export(MrsMorph_exports, {
  MrsMorph: () => MrsMorph,
  MrsMorphPro: () => MrsMorphPro
});
module.exports = __toCommonJS(MrsMorph_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
var import_helpers = require("./helpers.js");
function morphMap(mapId, title) {
  return (0, import_core.mapSchemaWithDefaults)({
    mapId,
    title,
    layers: [
      (0, import_topo_map.pointLayer)({
        layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
        title,
        source: (0, import_core.cartographerSourceWithDefaults)({
          layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
          attribution: []
        }),
        defaultAttribute: "index8",
        defaultZOrder: "timestamp",
        attributes: [
          (0, import_topo_map.attributeGroup)({
            label: "Survey Details",
            attributes: [
              (0, import_topo_map.stringAttr)({
                attributeId: "riverName",
                label: "River",
                showDistribution: false,
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "reachName",
                label: "Reach",
                showDistribution: false,
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "subreachName",
                label: "Subreach",
                showDistribution: false,
                buckets: "auto"
              }),
              import_helpers.moduleNumberAttr,
              (0, import_topo_map.stringAttr)({
                attributeId: "projectName",
                label: "Project Name",
                showDistribution: false,
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectCode",
                label: "MoRPh Correlation Code",
                showDistribution: false,
                buckets: "auto"
              }),
              (0, import_topo_map.teamAttr)("teamId", "Team"),
              (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
              (0, import_topo_map.timestampAttr)({
                attributeId: "timestamp",
                label: "Date/Time",
                buckets: "auto"
              }),
              (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Channel Characteristics",
            attributes: [
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 1: Number of Flow Types",
                attributeId: "index1",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.stringAttr)({
                label: "INDEX 2: Highest Energy Present/Extensive Flow Type",
                attributeId: "index2",
                buckets: [
                  (0, import_topo_map.lookupBucket)("DR", import_topo_map.marker.quality(0), "Dry"),
                  (0, import_topo_map.lookupBucket)("NP", import_topo_map.marker.quality(0.1), "No perceptible flow"),
                  (0, import_topo_map.lookupBucket)("SM", import_topo_map.marker.quality(0.2), "Smooth"),
                  (0, import_topo_map.lookupBucket)("RP", import_topo_map.marker.quality(0.3), "Rippled"),
                  (0, import_topo_map.lookupBucket)("UP", import_topo_map.marker.quality(0.5), "Upwelling"),
                  (0, import_topo_map.lookupBucket)("UW", import_topo_map.marker.quality(0.6), "Unbroken standing waves"),
                  (0, import_topo_map.lookupBucket)("BW", import_topo_map.marker.quality(0.8), "Broken standing waves"),
                  (0, import_topo_map.lookupBucket)("CH", import_topo_map.marker.quality(0.9), "Chute"),
                  (0, import_topo_map.lookupBucket)("FF", import_topo_map.marker.quality(1), "Free fall")
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 3: Number of Bed Material Types",
                attributeId: "index3",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.stringAttr)({
                label: "INDEX 4: Coarsest Present/Extensive Mineral Bed Material Type",
                attributeId: "index4",
                buckets: [
                  (0, import_topo_map.lookupBucket)("BE", import_topo_map.marker.quality(0), "Bedrock"),
                  (0, import_topo_map.lookupBucket)("BO", import_topo_map.marker.quality(0.1), "Boulder"),
                  (0, import_topo_map.lookupBucket)("CO", import_topo_map.marker.quality(0.3), "Cobble"),
                  (0, import_topo_map.lookupBucket)("GP", import_topo_map.marker.quality(0.5), "Gravel-Pebble"),
                  (0, import_topo_map.lookupBucket)("SA", import_topo_map.marker.quality(0.8), "Sand"),
                  (0, import_topo_map.lookupBucket)("SI", import_topo_map.marker.quality(0.9), "Silt"),
                  (0, import_topo_map.lookupBucket)("CL", import_topo_map.marker.quality(1), "Clay")
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 5: Average Alluvial Bed Material Size (Phi Units)",
                attributeId: "index5",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(-8, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(-6, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(-4, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(-2, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(8, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.stringAttr)({
                label: "INDEX 6: Average Alluvial Bed Material Size Class",
                attributeId: "index6",
                buckets: [
                  (0, import_topo_map.lookupBucket)("BO", import_topo_map.marker.quality(0.1), "Boulder"),
                  (0, import_topo_map.lookupBucket)("CO", import_topo_map.marker.quality(0.3), "Cobble"),
                  (0, import_topo_map.lookupBucket)("GP", import_topo_map.marker.quality(0.5), "Gravel-Pebble"),
                  (0, import_topo_map.lookupBucket)("SA", import_topo_map.marker.quality(0.8), "Sand"),
                  (0, import_topo_map.lookupBucket)("SI", import_topo_map.marker.quality(0.9), "Silt"),
                  (0, import_topo_map.lookupBucket)("CL", import_topo_map.marker.quality(1), "Clay")
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 7: Extent Of Superficial Bed Siltation",
                attributeId: "index7",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(1)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 8: Channel Physical Habitat Complexity",
                attributeId: "index8",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 9: Number of Aquatic Vegetation Morphotypes",
                attributeId: "index9",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(1))
                ]
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Riparian Characteristics (Bank Top and Bank Face)",
            attributes: [
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 10: Riparian Physical Habitat Complexity",
                attributeId: "index10",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 11: Riparian Vegetation Structural Complexity",
                attributeId: "index11",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(8, import_topo_map.marker.quality(1))
                ]
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Human Pressures and Impacts",
            attributes: [
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 12: Degree of Human Pressure Imposed by Bank Top Land Cover",
                attributeId: "index12",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(0))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 13: Channel Reinforcement",
                attributeId: "index13",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0.9)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(0))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                label: "INDEX 14: Non-Native Invasive Plant Species Extent",
                attributeId: "index14",
                decimalPlaces: 0,
                buckets: [
                  (0, import_topo_map.thresholdBucket)(null, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(0.5, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(1.5, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.thresholdBucket)(2.5, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.thresholdBucket)(3.5, import_topo_map.marker.quality(0))
                ]
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Non-Native Invasive Plants",
            attributes: [
              (0, import_helpers.invasivePlantAttr)("himalayanBalsam", "Himalayan Balsam"),
              (0, import_helpers.invasivePlantAttr)("japaneseKnotweed", "Japanese Knotweed"),
              (0, import_helpers.invasivePlantAttr)("giantHogweed", "Giant Hogweed"),
              (0, import_helpers.invasivePlantAttr)("floatingPennywort", "Floating Pennywort")
            ]
          })
        ]
      })
    ]
  });
}
const MrsMorph = morphMap((0, import_topo_map.unsafeMapId)("mrsMorph"), "MoRPh");
const MrsMorphPro = morphMap((0, import_topo_map.unsafeMapId)("mrsMorphPro"), "MoRPh");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsMorph,
  MrsMorphPro
});
//# sourceMappingURL=MrsMorph.js.map
